

<!-- <app-pagina-welcome></app-pagina-welcome> -->


<!-- <router-outlet class="router" [routerLink]="['/login-aws']" *ngIf="flag_showLogin"></router-outlet> -->
<router-outlet></router-outlet> 



